const PromoCategoryModel = {
  state: {
    isPromoted: false,
    category: "",
    id: -1,
    promoEventLoading: false,
    promoCompetitionLoading: false,
    promoSportLoading: false,
  },
  reducers: {
    updatePromotedCategory: (state: Record<string, any>, payload: any) => {
      return {
        ...state,
        isPromoted: payload.isPromoted,
        category: payload.category,
        id: payload.id,
      };
    },
    resetPromotedCategory: (state: Record<string, any>, payload: any) => {
      return {
        ...state,
        isPromoted: false,
        category: "",
        id: -1,
        promoEventLoading: false,
        promoCompetitionLoading: false,
        promoSportLoading: false,
      };
    },
    updatePromoEventLoading: (state: Record<string, any>, payload: any) => {
      return {
        ...state,
        promoEventLoading: payload,
        promoCompetitionLoading: false,
        promoSportLoading: false,
      };
    },
    updatePromoCompetitionLoading: (
      state: Record<string, any>,
      payload: any
    ) => {
      return {
        ...state,
        promoEventLoading: false,
        promoCompetitionLoading: payload,
        promoSportLoading: false,
      };
    },
    updatePromoSportLoading: (state: Record<string, any>, payload: any) => {
      return {
        ...state,
        promoEventLoading: false,
        promoCompetitionLoading: false,
        promoSportLoading: payload,
      };
    },
  },
  effects: {},
};
export default PromoCategoryModel;
